import { connect } from 'react-redux';

import RoleTabs from './RoleTabs';

const mapStateToProps = (state) => {
  return {
    editPermissions: state.rolesPermissions.editPermissions,
    isLoadingRole: state.rolesPermissions.isLoadingRole,
    roleRequestBody: state.rolesPermissions.roleRequestBody,
  };
};

export default connect(mapStateToProps)(RoleTabs);
